import { getUrl, Post, Upload, Get, Put } from './customer-support'

export const getListAgency = async body => {
  return Post(getUrl('cnps.agent.agency.list'), body)
}

export const DetailAgency = async id => {
  return Get(getUrl('cnps.agent.agency.detail', { id }))
}

export const createAgency = async body => {
  return Post(getUrl('cnps.agent.agency.create'), body)
}
export const updateAgency = async body => {
  return Put(getUrl('cnps.agent.agency.update'), body)
}

export const historyUpdateAgency = async id => {
  return Get(getUrl('cnps.agent.agency.list-change-history', { id }))
}
export const checkCodeExists = async agencyCode => {
  return Get(getUrl('cnps.agent.agency.check-register-agency-code', { agencyCode }))
}

export const UploadFile = async (formData, onUploadProgress) => {
  const url = getUrl('cnps.cfg.upload-files-s3')
  const results = await Upload(url, formData, onUploadProgress)
  return results
}
